import { ClosetObject } from '@sas-dvr/ltjs-commons';

function releaseWrappers(target: any) {
  const names: Set<string> | null | undefined = target.__ltjsPropertyNames;
  if (names) {
    names.forEach((value) => {
      target[value] = null;
    });
  }
  target.__wrappersReleased = true;
}

// For some reason type checking expects any or void here...
export function ltjsProperty(this: void, _target: Object, key: string): any {
  // let val: ClosetObject | null | undefined;
  return {
    get(this: any) {
      if (this.__wrappersReleased) {
        throw new Error(`wrappersReleased,  unable to get ${key}`);
      }
      return this['__' + key];
    },
    set(this: any, value: ClosetObject | null | undefined) {
      if (!this.__ltjsPropertyNames) {
        this.__ltjsPropertyNames = new Set<string>();
      }
      this.__ltjsPropertyNames.add(key);
      const oldValue = this['__' + key];
      if (oldValue) {
        oldValue.release();
      }
      this['__' + key] = value;
      if (value) {
        value.retain();
      }
    },
    enumerable: true,
    configurable: true,
  } as PropertyDescriptor;
}

export function ltjsDestructor(this: void, _target: any, _key: string, descriptor: any): any {
  const fn = descriptor.value;

  let wrapped = function (this: any) {
    const rc = fn.apply(this, arguments);
    releaseWrappers(this);
    return rc;
  };

  return {
    configurable: true,
    get() {
      return wrapped;
    },
    set(value: any) {
      wrapped = value;
    },
  } as PropertyDescriptor;
}

export function ltjsReactComponent(this: void, target: Function) {
  const oldFunction = target.prototype.componentWillUnmount;
  target.prototype.componentWillUnmount = function () {
    if (oldFunction) {
      oldFunction.apply(this, arguments);
    }
    releaseWrappers(this);
  };
}
